module.exports = __webpack_public_path__ + "img/food-7.8dc894c1.jpg";